import { getLocale } from "../runtime";

const sv_iconcheck = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Framgång`
};

const iconcheck = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iconcheck(inputs)
	return "iconCheck";
};

export { iconcheck as "iconCheck" };